import Icon from '../components/Icon.vue'

Icon.register({
  unlock: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 256c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-160c0-26.5 21.5-48 48-48h24v-102.5c0-84 67.5-153.2 151.5-153.5s152.5 68 152.5 152v16c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24v-16c0-39.9-32.7-72.4-72.7-72-39.6 0.4-71.3 33.3-71.3 72.9v103.1h248z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/unlock.js
// module id = 2052
// module chunks = 0